<template>
  <model-form
    ref="form"
    :model="reportCategory"
    modal-type="modal"
    @change="$emit('change')"
  >
    <div class="column">
      <div class="row q-gutter-md">
        <q-input
          v-model="reportCategory.name"
          class="col"
          label="Name"
          :rules="[val => !!val || 'Field is required']"
          bottom-slots
          autofocus
        />
      </div>
    </div>
  </model-form>
</template>
<script>

import ModelForm from 'src/modules/admin/components/ModelForm/ModelForm'

export default {
  name: 'ReportCategoryForm',
  components: {
    ModelForm
  },
  models: {
    reportCategory: 'default'
  },
  emits: ['change'],
  methods: {
    show (model, initialData) {
      this.$refs.form.show(model, initialData)
    }
  }
}

</script>
